export default __webpack_public_path__ + "static/media/no-support-device.7c57906a.svg";